ixModuleRouting("impactx.profile", {
    "/userprofile": {
        templateUrl: "modules/profile/templates/profile.html",
        controller: "ProfileCtrl",
        controllerAs: "ctrl",
        process: "EditProfile",
    }
});
